/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import ThreeDotsLoader from '../../../../Components/LoadingDots';

function AddCategoryModal({
    addCategoryPopup, selected, setAddcategoryPopup, createResoureCategory, addCategoryDetails, setaddCategoryDetails, setsubmitSelected, submitSelected, setThreeDotsLoader, threeDotLoader, setIsEdit, isEdit, handleClose,
}) {
    if (isEdit) {
        useEffect(() => {
            setaddCategoryDetails((prevState) => ({
                ...prevState,
                name: selected.name,
                description: selected.description,
            }));
        }, [isEdit]);
    }

    const InputChange = (e, index) => {
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '') {
            setaddCategoryDetails((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setaddCategoryDetails((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
    };

    return (
        <div className={`modal fade fixed top-0 left-0 ${addCategoryPopup ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="add-category" tabIndex="-1" aria-labelledby="exampleModalCenterTitle" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative min-w-[449px] max-w-[449px] pointer-events-none" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative py-[26px]">
                        <h5 className="text-xs4 font-semibold leading-normal text-[#090406] email" id="exampleModalScrollableLabel">
                            {!isEdit ? 'Add Category' : 'Update Category'}
                        </h5>
                        <button
                            type="button"
                            className="absolute top-5 right-3"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => { setAddcategoryPopup(false); handleClose(); }}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative px-[46px]">
                        <div className="relative w-full">
                            <input
                                type="text"
                                id="name"
                                className="h-12 w-full rounded-lg outline-0 error2 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3"
                                autoComplete="off"
                                value={addCategoryDetails.name}
                                onChange={(e) => {
                                    InputChange(e);
                                    setsubmitSelected(false);
                                }}
                            />
                            <label htmlFor="name" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                Title
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                            {submitSelected && addCategoryDetails.name === '' && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Title is required</p>}
                        </div>
                        <div className="relative w-full mt-6">
                            <textarea
                                type="text"
                                id="description"
                                className="w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal resize-none text-[#090406] px-3 py-5 h-[150px] error2"
                                autoComplete="off"
                                value={addCategoryDetails.description}
                                onChange={(e) => {
                                    InputChange(e);
                                    setsubmitSelected(false);
                                }}
                            />
                            <label htmlFor="description" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                Description
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                            {submitSelected && addCategoryDetails.description === '' && <p className="error1 font-normal text-xs3 text-[#ED1C24] mt-1">Description is required</p>}
                        </div>
                    </div>
                    <div className="flex justify-center my-[22px]">
                        <button
                            type="button"
                            className="rounded-lg font-normal text-sm text-white bg-[#555259] w-[242px] py-3 outline-0"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => createResoureCategory()}
                        >
                            {threeDotLoader ? <div className="ml-[105px]"><ThreeDotsLoader /></div> : (isEdit ? 'Update Category' : 'Add Category')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddCategoryModal;
